import React from 'react';
import { IconButtonStyled } from './common/IconButtonStyled';
import { IconStyled } from './common/IconStyled';

interface Props {
  isPlaying: boolean;
  onClick(): void;
}

const PlayPauseButton: React.FC<Props> = ({ isPlaying, onClick }) => {
  return (
    <IconButtonStyled title={isPlaying ? 'Pause' : 'Play'} onClick={onClick}>
      <IconStyled icon={isPlaying ? 'pause' : 'play'} />
    </IconButtonStyled>
  );
};

export default PlayPauseButton;
